import JSData from 'js-data'
import _ from 'lodash'
import httpAdapter from './adapters/http.js'
// import socketAdapter from './adapters/socket.js'

const store = new JSData.DS();
const findStrategy = function(Resource, data, cb) {
  cb(null, data.data || data)
}

_.assign(store.defaults, {
  afterFind: findStrategy,
  afterFindAll: findStrategy,
  bypassCache: true
})

store.registerAdapter('http', httpAdapter, { default: true })
// store.registerAdapter('socket', socketAdapter, {})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js